// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__xo10K","buttons":"SendReceipts_buttons__2TQSn","email":"SendReceipts_email__1K7_s","bookApptTitle":"SendReceipts_bookApptTitle__2GZkY"};